/**
 * GuvenliHtml.jsx — personelin yazdığı HTML'i arındırarak çizer (backlog #536, 2026-10-21).
 *
 * Onay metinlerinin gövdesi (icerik) ham HTML'dir (CKEditor çıktısı: satır içi stiller, &nbsp;, <hr />); sunucu onu
 * olduğu gibi saklar, doğrulamaz ya da kaçışlamaz. Bu yüzden ekrana yalnızca buradan basılır: DOMPurify betiği, olay
 * özniteliklerini, javascript: adreslerini ve <style> etiketini atar (<style> bütün arayüzü boyayabilir). Metinleri
 * gösteren her yer — yönetim önizlemesi ve kullanıcının onay ekranı — AYNI bileşeni kullanır, yönetimde görülen kullanıcının
 * göreceğidir.
 */
import React, { useMemo } from "react";
import DOMPurify from "dompurify";

// Dışarı açılan bağlantı yeni sekmede açılır; opener'a erişemez.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("href")) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

/** HTML dizgisini arındırılmış HTML dizgisine çevirir. Boş ya da dizgi olmayan girdi "" olur. */
export function temizHtml(html) {
  if (typeof html !== "string" || !html.trim()) return "";
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["style", "form", "input", "button", "textarea", "select"],
    ADD_ATTR: ["target"],
  });
}

/**
 * @param {string}  html       ham HTML
 * @param {string}  className  ek sınıf
 */
export default function GuvenliHtml({ html, className = "", ...rest }) {
  const temiz = useMemo(() => temizHtml(html), [html]);
  return (
    // temiz, DOMPurify'dan geçmiş HTML'dir (temizHtml)
    <div className={`onay-metni-govde ${className}`.trim()} dangerouslySetInnerHTML={{ __html: temiz }} {...rest} />
  );
}
